import { Injectable } from '@angular/core';
import { ListaTrabajadores } from 'src/app/shared/models/trabajadores/trabajadores.interface';
import { TrabajadoresService } from '../../trabajadores/trabajadores.service';
import { CorreccionMonetaria, 
        DeclaracionJurada, 
        ImpuestoUnicoTrabajador, 
        TablaMesesLiquidados, 
        TablaMontosAnuales, 
        RentaTotalNoGravadaTrabajador, 
        TablaMontosTotales,
        TablaTotalMontosMensuales,} from 'src/app/shared/models/declaracionjurada/declaracionjurada.interface';
import { OpcionElegidaDDJJ } from 'src/app/shared/models/opcioneselegidas.interface';
import { Empresa } from 'src/app/shared/models/empresas.interface';
import { EmpresaService } from '../../empresas.service';
import { DeclaracionDDJJService } from '../../declaracion/declaracion.service';
import { contabilidadService } from '../../contabilidad/contabilidad.service';
import { Ciudad } from 'src/app/shared/models/ciudades.interface';
import { CiudadService } from '../../ciudades.service';
import { TablaMontosMensuales } from '../../../../shared/models/declaracionjurada/declaracionjurada.interface';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { FactorActualizacion, UF } from 'src/app/shared/models/valoresUF.interface';
import Swal from 'sweetalert2';
import { formatRut } from 'rutlib/lib';
import JSZip from 'jszip';
// import { read, write, writeFile } from "xlsx";

@Injectable({
    providedIn: 'root'
})
export class GenerarDDJJService {
    LOGO_SII = 'data:image/jpeg;base64,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'
    TEXT_HEADER_DOCUMENT = 'Declaración facturada Anual sobre Rentas del Art. 42 N1 (Sueldos), otros componentes\nde la remuneración retenciones del Impuesto único de Segunda Categoría'
    DECLARACION_ORIGINAL = "ORIGINAL";
    DEFAULT_ALIGNMENT = 'center'; // ALINEACION POR DEFECTO DEL TEXTO EN LAS CELDAS DE LAS TABLAS DEL PDF

    documentoDDJJ:DeclaracionJurada; //ESQUELETO DEL DOCUMENTO
    trabajadores:ListaTrabajadores[] = []; //LISTA DE TRABAJADORES
    empresa: Empresa;
    ciudad: Ciudad;
    correccionMonetaria: CorreccionMonetaria[];
    periodoTributario:string = '';
    rutDeclarante:string = '';
    rutAnterior:string = '';
    libroRemuneraciones:any[] = []; // LISTA DE LIQUIDACIONES
    haberesTrabajador: any[] = []; //LISTA DE HABERES DE LOS TRABAJADORES
    impuestoUnicos:any[] = []; // LISTA DE IMPUESTO UNICOS DE LOS TRABAJADORES
    exportarDatos: string = '';
    factoresAcualizacion: any[] = [];
    tipoDeclaracion:string = '';
    folioAnterior:string = '';
    textoplano_ddjj1887 = '';
    zip = new JSZip();

    anio:number = 0;
    periodoInicial:Date = new Date();
    periodoFinal:Date = new Date();
    pdfMake:any;
    // pdfBase64:string;
    // CONSTRUCTOR
    constructor
    (
        private trabajadorservice:TrabajadoresService,
        private empresaService:EmpresaService,
        private ciudadService: CiudadService,
        private declaracionService:DeclaracionDDJJService,
        private ventaService:contabilidadService,
        private alert:AlertHelper,
    ) { }
    // GENERA EL DOCUMENTO
    generarDocumento(opciones_elegidas: OpcionElegidaDDJJ){
        this.libroRemuneraciones = []; // RESETEO LOS DATOS DEL LIBRO DE REMUNERACIONES
        // MODAL VISUAL CARGA DOCUMENTO
        Swal.fire({
            title: 'Generando el documento',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        });

        try {
            this.exportarDatos = opciones_elegidas.formato;
            this.periodoTributario = String(opciones_elegidas.periodo_declatorio + 1);

            opciones_elegidas.rut_anterior = opciones_elegidas.rut_anterior?.replace(/[.-]/g, '')??'';
            this.rutAnterior = opciones_elegidas.rut_anterior;
            
            this.tipoDeclaracion = opciones_elegidas.tipo_declaracion;
            this.empresaService.obtenerEmpresa(parseInt(opciones_elegidas.empresa))
            .subscribe(({ data: empresa }) => {
                this.empresa = empresa;
                this.ciudadService.traerCiudadPorId(this.empresa.ciudad).subscribe(({data}) => {
                    this.ciudad = data;
                });
                const rutDeclaranteSinFormato = this.empresa.cedula.replace(/[.-]/g, '');
                this.rutDeclarante = rutDeclaranteSinFormato;
            });
            this.cargarDatosTrabajadores
            (
                opciones_elegidas.periodo_declatorio,
                parseInt(opciones_elegidas.empresa)
            ).then(() => {
                // VERIFICO SI EXISTEN REGISTROS EN EL LIBRO DE REMUNERACIONES
                if (this.libroRemuneraciones.length <= 0 || !this.filtarLiquidaciones()) {
                    this.alert.error_small('No existen registros en el libro.');
                    return;
                }
                // CARGO LOS DATOS DEL HEADER DEL PDF: DATOS DE LA EMPRESA
                this.cargarHeader(opciones_elegidas).then(() => {
                    this.obtenerFactorActualizacion(opciones_elegidas.periodo_declatorio)
                    .then((data:FactorActualizacion[]) => {
                        this.cargarDatosTablas(data);
                        // OPCIONES DE GENERACION DEL ARCHIVO (PDF O TEXTO)
                        switch (this.exportarDatos) {
                            case "PDF":
                                this.convertToPDF();
                                break;
                            case "TEXTO":
                                this.convertToText();

                                const fileName:string = this.empresa.cedula.replace(/[.-]/g, '').slice(0, -1)+'.887';
                                this.zip.file(fileName, this.textoplano_ddjj1887);
                                // SE GENERA EL ARCHIVO ZIP CON EL TEXTO PLANO DENTRO
                                this.zip.generateAsync({type: 'blob'}).then((blob) => {
                                    const url = window.URL.createObjectURL(blob);
                                    const link = document.createElement('a');
                                    link.href = url;
                                    link.download = this.empresa.cedula.replace(/[.-]/g, '').slice(0, -1)+'.zip';
                                    link.click();
                                    window.URL.revokeObjectURL(url);
                                })
                                break;
                            default:
                                throw Error('No hubo seleccion en el tipo de exportacion de datos.');
                        }
                        Swal.close();
                    });
                });
            });    
        } catch (error) { Swal.close(); throw Error("Error: "+error); }
    }
    // CARGA EL HEADER DEL DOCUMENTO CON LOS DATOS QUE SE OCUPARAN
    async cargarHeader(opcionElegida:OpcionElegidaDDJJ){
        try {
            return new Promise((resolve) => {
                this.declaracionService.traerUltimoFolio().subscribe(({ data: folio }) => {
                    this.documentoDDJJ = {
                        empresa: this.empresa,
                        periodoTributario: this.periodoTributario,
                        folio: opcionElegida.folio === 0 ? folio : opcionElegida.folio, 
                        estado: opcionElegida.tipo_declaracion === this.DECLARACION_ORIGINAL,
                        folioAnterior: opcionElegida.folio_anterior !== null ? opcionElegida.folio_anterior.toString() : '',
                        rutAnterior: opcionElegida.rut_anterior !== null ? formatRut(opcionElegida.rut_anterior) : null,
                    }
                    const periodo = opcionElegida.periodo_declatorio;
                    this.declaracionService.traerCorreccionMonetaria(periodo.toString()).subscribe(({data}) => {
                        const correciones: any[] = data.filter((d:CorreccionMonetaria) => d !== null);
                        this.correccionMonetaria = correciones.map((correccion, index) => ({
                            mes: index,
                            correcion: correccion
                        }));
                        resolve(1);
                    });
                });
            });
        } catch (error) { Swal.close(); throw new Error("Error: "+error) }
    }
    // CARGA EL DOCUMENTO DDJJ CON LOS DATOS  
    cargarDatosTablas(valoresUF:FactorActualizacion[]){
        // INICIALIZAMOS EL OBJETO
        this.documentoDDJJ = {
            ...this.documentoDDJJ,
            tablaMontosMensuales: [],
            tablaMesesLiquidado: [],
            tablaMontosAnuales: [],
            tablaTotalMontosMensuales: [],
        }
        let totalLeyesSociales: number = 0;
        const totalRentasAnuales:TablaMontosTotales = {
            rentaTotal: {
                rentaTotalActualizado: 0,
                rentaTotalSinActualizar: 0,
            },
            rentaTotalNoGravada: {
                rentaTotalNoGravadaActualizado: 0,
                rentaTotalNoGravadaSinActualizar: 0,
            },
            rentaTotalExenta: {
                rentaTotalExentaActualizado: 0,
                rentaTotalExentaSinActualizar: 0,
            },
            totalRebajasExtremas: {
                rebajaZonasExtremasActualizado: 0,
                rebajaZonasExtremasSinActualizar: 0,
            },
            impuestoUnicoTotalRetenida: {
                retenidoAccesoriasComplementaria: 0,
                retenidoAnio: 0,
                total: 0
            },
            leyesSociales: 0,
            prestamo3Porciento: {
                prestamo3PorcientoActualizado: 0,
                prestamo3PorcientoSinActualizar: 0,
            },
            mayorRetencion: 0,
            totalRemununeracionImponible: 0,
        };
        const mesesTotales:TablaTotalMontosMensuales[] = [];
        let tablaMontosAnuales:TablaMontosAnuales;
        // console.log(this.libroRemuneraciones);
        Object.keys(this.libroRemuneraciones).forEach(rut => {
            const tablaMontosMensuales: TablaMontosMensuales[] = [];
            const tablaMesesLiquidado:TablaMesesLiquidados[] = [];
            
            const totalImpuestosUnicos:ImpuestoUnicoTrabajador = {
                impuestoActualizado: 0,
                impuestoSinActualizar: 0,
            };
            const rentaTotalNoGravadaTrabajador: RentaTotalNoGravadaTrabajador = {
                rentaTotalNoGravadaActualizado: 0,
                rentaTotalNoGravadaSinActualizar: 0
            }
            // FOREACH AL LIBRO DE REMUNERACIONES
            this.libroRemuneraciones[rut].forEach((libro:any) => {
                // OBTENGO Y CONVIERTO LA FECHA DEL REGISTRO DEL LIBRO
                const fechaLiquidacion = new Date(libro.f_liquidacion+'T00:00:00');
                const mesLiquidacion = fechaLiquidacion.getMonth();
                // BUSCO LA CORRECCION MONETARIA DE ACUERDO AL MES 
                const correccionMonetaria = this.correccionMonetaria.find(c => c.mes === mesLiquidacion);
                // MONTO MENSUAL
                const totalMonto = libro.totalimp - libro.totaldescuento;
                tablaMontosMensuales.push({
                    mes: mesLiquidacion,
                    monto: totalMonto,
                }); 
                // MESES LIQUIDADOS
                tablaMesesLiquidado.push({
                    mes: mesLiquidacion,
                });
                // TOTALES MENSUALES
                if (mesesTotales.some(x => x.mes === mesLiquidacion)) { //SI EXISTE EL MES AGREGADO AL ARRAY, SOLO SUMAR EL MONTO
                    const index = mesesTotales.findIndex(x => x.mes === mesLiquidacion);
                    mesesTotales[index].monto += totalMonto;
                }else{ // SI NO EXISTE, AGREGAR EL MES Y EL MONTO
                    mesesTotales.push({
                        mes: mesLiquidacion,
                        monto: totalMonto,
                    });
                }
                // --------------APLICACION DE CORRECCION MONETARIA A LOS MONTOS--------------- //
                let correccionAfecta:number = 0
                let montoTotal:number = 0;
                // IMPUESTO UNICO - RENTA TOTAL NO GRAVADA - LEYES SOCIALES (SIN ACTUALIZAR)
                totalImpuestosUnicos.impuestoSinActualizar += libro.impuestounico;
                rentaTotalNoGravadaTrabajador.rentaTotalNoGravadaSinActualizar += libro.totalnoimp;

                totalLeyesSociales += libro.prevision +  libro.salud + libro.scesantia + libro.seguroInvalidez + libro.totalaportesempleador;

                // IMPUESTO UNICO ACTUALIZADO - RENTA TOTAL NO GRAVADA SIN ACTUALIZAR
                // VERIFICO SI LA CORRECCION MONETARIA DEL MES, SI ES VACIO, DEJAR SIN ACTUALIZAR
                if (correccionMonetaria.correcion === '') 
                { 
                    totalImpuestosUnicos.impuestoActualizado +=  libro.impuestounico; 
                    rentaTotalNoGravadaTrabajador.rentaTotalNoGravadaActualizado += libro.totalnoimp;
                }else{
                    // REMPLAZAR LAS COMAS POR PUNTOS: ESTO DEBIDO A QUE AL PARSEAR LAS COMAS NO LAS TOMAS COMO SEPARADOR DECIMAL
                    // TRANSFORMO LA CORRECCION MONETARIA EN PORCENTAJE
                    let correccionNumber = parseFloat(correccionMonetaria.correcion.replace(",", ".")) / 100;
                    // SI LA CORRECCION ES MENOR A 0, "NO SE REALIZA LA CORRECCION MONETARIA" YA QUE SE DEBE CAMBIAR A 0
                    if (correccionNumber < 0) 
                    { 
                        totalImpuestosUnicos.impuestoActualizado += libro.impuestounico;
                        rentaTotalNoGravadaTrabajador.rentaTotalNoGravadaActualizado += libro.totalnoimp;
                    }else{
                        // IMPUESTO UNICO
                        correccionAfecta = libro.impuestounico * correccionNumber;
                        montoTotal = libro.impuestounico + correccionAfecta;
                        totalImpuestosUnicos.impuestoActualizado += montoTotal;
                        // RENTA TOTAL NO GRAVADA
                        correccionAfecta = libro.totalnoimp * correccionNumber;
                        montoTotal = libro.totalnoimp + correccionAfecta;
                        rentaTotalNoGravadaTrabajador.rentaTotalNoGravadaActualizado += montoTotal;
                    }
                }
                
            });
            // AGREGO LOS OBJETOS AL ARRAY DE LA TABLA MESES LIQUIDADOS DEL DOCUMENTO
            this.documentoDDJJ.tablaMesesLiquidado[rut] = tablaMesesLiquidado;
            this.documentoDDJJ.tablaMontosMensuales[rut] = tablaMontosMensuales;
            // PARSEO EL RUT DEL TRABAJADOR A NUMERICO
            const rutTrabajador = parseInt(rut);
            // SUMA DE LOS TOTALES RENTAS DE LOS TRABAJADORES
            const rentaSinActualizar = this.documentoDDJJ.tablaMontosMensuales[rut].reduce((a: number, element : TablaMontosMensuales) => 
                { return a + element.monto; }, 
            0);
            // SUMA DE LOS TOTALES RENTAS DE LOS TRABAJADORES ACTUALIZADOS (CORRECCION MONETARIA)
            const rentaActualizada:number = this.documentoDDJJ.tablaMontosMensuales[rut].reduce((a: number, element : TablaMontosMensuales) => {
                // BUSCO LA CORRECCION MONETARIA DE ACUERDO AL MES
                const correccionMonetaria = this.correccionMonetaria.find(c => c.mes === element.mes);
                if (correccionMonetaria.correcion === '') { return a + element.monto; }
                // REMPLAZO LAS COMAS POR PUNTOS: ESTO DEBIDO A QUE AL PARSEAR LAS COMAS NO LAS TOMAS COMO SEPARADOR DECIMAL
                let correccionNumber = parseFloat(correccionMonetaria.correcion.replace(",", ".")) / 100;
                // SI LA CORRECCION ES MENOR A 0, NO SE REALIZA LA CORRECCION MONETARIA
                if (correccionNumber < 0) { return a + element.monto }

                let correccionAfecta = element.monto * correccionNumber;
                const monto = element.monto + correccionAfecta;
                return a + monto;
            }, 0);
            // SUMA DE LOS TOTALES DE LAS RENTAS + EL FACTOR DE ACTUALIZACION DE LAS RENTAS UF
            totalRentasAnuales.totalRemununeracionImponible += this.documentoDDJJ.tablaMontosMensuales[rut].reduce((a:number, element:TablaMontosMensuales) => {
                const factor = valoresUF[element.mes].factor;
                return a + (element.monto * factor);
            }, 0);
            // CARGO EL OBJETO "tablaMontosAnuales" CON LOS DATOS GENERADOS
            tablaMontosAnuales = {
                rutTrabajador: rutTrabajador.toString(),
                rentaTotalTrabajador: {
                    rentaActualizada: Math.round(rentaActualizada),
                    rentaSinActualizar: rentaSinActualizar,
                },
                impuestoUnicoTrabajador: {
                    impuestoActualizado: totalImpuestosUnicos.impuestoActualizado,
                    impuestoSinActualizar: totalImpuestosUnicos.impuestoSinActualizar,
                },
                mayorRetenecionTrabajador: {
                    mayorRetencionActualizado: 0,
                    mayorRetencionSinActualizar: 0,
                },
                rentaTotalNoGravadaTrabajador: {
                    rentaTotalNoGravadaActualizado: rentaTotalNoGravadaTrabajador.rentaTotalNoGravadaActualizado,
                    rentaTotalNoGravadaSinActualizar: rentaTotalNoGravadaTrabajador.rentaTotalNoGravadaSinActualizar,
                },
                rentaTotalExentaTrabajador: {
                    rentaTotalExentaActualizado: 0,
                    rentaTotalExentaSinActualizar: 0,
                },
                rebajaZonasExtremasTrabajador: {
                    rebajaZonasExtremasActualizado: 0,
                    rebajaZonasExtremasSinActualizar: 0,
                },
                prestamo3PorcientoTrabajador: {
                    prestamo3PorcientoActualizado: 0,
                    prestamo3PorcientoSinActualizar: 0,
                },
            }
            // PUSH TABLA MONTOS ANUALES 
            this.documentoDDJJ.tablaMontosAnuales.push(tablaMontosAnuales);
            this.documentoDDJJ.tablaTotalMontosMensuales = mesesTotales;
        });
        // TOTALES ANUALES
        // TOTALES RENTAS
        totalRentasAnuales.rentaTotal.rentaTotalActualizado = this.documentoDDJJ.tablaMontosAnuales.reduce((a, item) => {
            return a + item.rentaTotalTrabajador.rentaActualizada;
        }, 0);
        totalRentasAnuales.rentaTotal.rentaTotalSinActualizar = this.documentoDDJJ.tablaMontosAnuales.reduce((a, item) => {
            return a + item.rentaTotalTrabajador.rentaSinActualizar;
        }, 0);
        // IMPUESTO SEGUNDA CATEGORIA
        totalRentasAnuales.impuestoUnicoTotalRetenida.retenidoAnio = this.documentoDDJJ.tablaMontosAnuales.reduce((a, item) => {
            return a + item.impuestoUnicoTrabajador.impuestoSinActualizar;
        }, 0);
        totalRentasAnuales.impuestoUnicoTotalRetenida.total = this.documentoDDJJ.tablaMontosAnuales.reduce((a, item) => {
            return a + item.impuestoUnicoTrabajador.impuestoActualizado;
        }, 0);
        // RENTA TOTAL NO GRAVADA
        totalRentasAnuales.rentaTotalNoGravada.rentaTotalNoGravadaSinActualizar = this.documentoDDJJ.tablaMontosAnuales.reduce((a, item) => {
            return a + item.rentaTotalNoGravadaTrabajador.rentaTotalNoGravadaSinActualizar;
        }, 0);
        totalRentasAnuales.rentaTotalNoGravada.rentaTotalNoGravadaActualizado = this.documentoDDJJ.tablaMontosAnuales.reduce((a, item) => {
            return a + item.rentaTotalNoGravadaTrabajador.rentaTotalNoGravadaActualizado;
        }, 0);
        // RENTA TOTAL EXENTA
        totalRentasAnuales.rentaTotalExenta.rentaTotalExentaSinActualizar = this.documentoDDJJ.tablaMontosAnuales.reduce((a, item) => {
            return a + item.rentaTotalExentaTrabajador.rentaTotalExentaSinActualizar;
        }, 0);
        totalRentasAnuales.rentaTotalExenta.rentaTotalExentaActualizado = this.documentoDDJJ.tablaMontosAnuales.reduce((a, item) => {
            return a + item.rentaTotalExentaTrabajador.rentaTotalExentaActualizado;
        }, 0);
        // MAYOR RENTENCION
        totalRentasAnuales.mayorRetencion = this.documentoDDJJ.tablaMontosAnuales.reduce((a, item) => {
            return a + item.mayorRetenecionTrabajador.mayorRetencionActualizado;
        }, 0);
        // REBAJAS POR ZONAS EXTREMAS
        totalRentasAnuales.totalRebajasExtremas.rebajaZonasExtremasSinActualizar = this.documentoDDJJ.tablaMontosAnuales.reduce((a, item) => {
            return a + item.rebajaZonasExtremasTrabajador.rebajaZonasExtremasSinActualizar;
        }, 0);
        totalRentasAnuales.totalRebajasExtremas.rebajaZonasExtremasActualizado = this.documentoDDJJ.tablaMontosAnuales.reduce((a, item) => {
            return a + item.rebajaZonasExtremasTrabajador.rebajaZonasExtremasActualizado;
        }, 0);
        // LEYES SOCIALES
        totalRentasAnuales.leyesSociales = totalLeyesSociales;
        // 3% PRESTAMO
        totalRentasAnuales.prestamo3Porciento.prestamo3PorcientoSinActualizar = this.documentoDDJJ.tablaMontosAnuales.reduce((a, item) => {
            return a + item.prestamo3PorcientoTrabajador.prestamo3PorcientoSinActualizar;
        }, 0);
        totalRentasAnuales.prestamo3Porciento.prestamo3PorcientoActualizado = this.documentoDDJJ.tablaMontosAnuales.reduce((a, item) => {
            return a + item.prestamo3PorcientoTrabajador.prestamo3PorcientoActualizado;
        }, 0);
        // PUSH TABLA MONTOS TOTALES
        this.documentoDDJJ.tablaMontosTotales = totalRentasAnuales;
        // console.log(this.documentoDDJJ);
    }
    // OBTENER LA UF DE ACUERDO AL PERIODO SELECCIONADO
    obtenerFactorActualizacion(anio:number){
        return new Promise((resolve, reject) => {
            const ufs : UF[] = [];
            const factores : FactorActualizacion[] = [];
            fetch('https://mindicador.cl/api/uf/'+anio)
                .then(res => res.json())
                .then(({serie}) => {
                    // OBTENGO LAS ULTIMAS UF'S DE CADA MES DEL PERIODO
                    for (let mes = 0; mes < 12; mes++) {
                        const fecha = new Date(anio, mes + 1, 0).toISOString();
                        const valoresSplit : UF[] = serie.map((x:UF) => ({valor: x.valor, fecha: x.fecha.split('T')[0]}));
                        // console.log({valoresSplit});
                        const valores : UF = valoresSplit.find((x : UF) => x.fecha === fecha.split('T')[0]);
                        ufs.push(valores);
                    }
                    // CALCULAR EL FACTOR DE ACTUALIZACION
                    for (let mes = 0; mes < 12; mes++) {
                        const totalFactor = ufs[11].valor / ufs[mes].valor;
                        const factor : FactorActualizacion = {
                            mes: mes,
                            factor: Number(totalFactor.toFixed(2)),
                        }
                        factores.push(factor);
                    }
                    resolve(factores);
                })
            .catch((error: Error) => {
                console.error('ERROR: ', error.message);
                reject(error);
            });
        });
    }
    //  CONVIERTE ARCHIVO TEXTO PLANO (DECLARACION JURADA)
    convertToText(){
        // REGISTRO TIPO 0
        const codigoempresa = String().padStart(2, '0');
        const numerocliente = String().padStart(4, '0');
        const checksumDeclarante = String().padStart(10, '0');
        const checksumSII = String().padStart(10, '0');
        const codigopresentacion = 'I';
        const tipoDeclaracion = this.tipoDeclaracion === 'ORIGINAL' ? 'O':'R';
        const folioDoc = this.documentoDDJJ.folio.toString().padStart(2, '0');
        const numeroFolio = codigoempresa+this.rutDeclarante[1]+this.rutDeclarante[2]+this.rutDeclarante[3]+folioDoc;
        const fechaEnvio = String().padStart(2, '0') + String().padStart(2, '0') + String().padStart(4, '0');
        const horaEnvio = String().padStart(2, '0') + String().padStart(2, '0') + String().padStart(4, '0');
        const numeroVersion = String().padStart(2, '0');
        const numeroAtencion = String().padStart(8, '0');
        const numeroAnterior = this.rutAnterior+this.tipoDeclaracion === 'ORIGINAL' ? (' 0000000'):('R'+this.documentoDDJJ.folioAnterior)+String().padStart(6, ' ');
        const RegistroTipo0:string[] = [
            '0'+this.documentoDDJJ.periodoTributario+'1887',
            this.rutDeclarante.padStart(9, '0')+codigoempresa+numerocliente,
            checksumDeclarante+checksumSII,
            codigopresentacion+tipoDeclaracion,
            numeroFolio,
            fechaEnvio+horaEnvio,
            numeroVersion+numeroAtencion,
            String().padStart(255, ' ')+'\n',
        ];
        const fax = '56'+String().padStart(2, '0')+String().padStart(7, '0');
        const unidadCaja = String().padStart(5, '0');
        const numeroCaja = String().padStart(3, '0');
        const numeroPaquete = String().padStart(5, '0');
        const numeroTelefonico = this.documentoDDJJ.empresa.num_telefono??String().padStart(9, '0')+' ';
        const RegistroTipo1:string[] = [    
            '11'+this.documentoDDJJ.periodoTributario+'1887',
            codigopresentacion+numeroFolio+tipoDeclaracion,
            numeroAnterior,
            this.rutDeclarante.padStart(9, '0')+this.documentoDDJJ.empresa.nombre.padStart(30, ' '),
            String().padStart(260, ' ')+'\n',
            '12'+this.documentoDDJJ.empresa.ubicacion.padEnd(35, ' ')+this.ciudad.nombre.padEnd(15, ' ')+this.documentoDDJJ.empresa.correo.padEnd(30, ' '),
            fax,
            String().padStart(248, ' ')+'\n',
            '1356'+numeroTelefonico,
            codigoempresa+numerocliente,
            unidadCaja+numeroCaja+numeroPaquete,
            String().padStart(308, ' ')+'\n',
        ];
        const RegistroTipo2:string[] = [];
        this.documentoDDJJ.tablaMontosAnuales.forEach((element:TablaMontosAnuales) => {
            const datosInicio = '21887I'+numeroFolio+this.rutDeclarante.padStart(9, '0');
            let meseseTrabajadoCadena = '';
            let totalMontoMesesCadena = '';
            const datosTrabajador = element.rutTrabajador.toString().padStart(9, '0')
                +element.rentaTotalTrabajador.rentaActualizada.toString().padStart(12, '0')
                +element.impuestoUnicoTrabajador.impuestoActualizado.toString().padStart(12, '0')
                +element.mayorRetenecionTrabajador.mayorRetencionActualizado.toString().padStart(12, '0')
                +element.rentaTotalNoGravadaTrabajador.rentaTotalNoGravadaActualizado.toString().padStart(12, '0')
                +element.rentaTotalExentaTrabajador.rentaTotalExentaActualizado.toString().padStart(12, '0')
                +element.rebajaZonasExtremasTrabajador.rebajaZonasExtremasActualizado.toString().padStart(12, '0')
                +element.prestamo3PorcientoTrabajador.prestamo3PorcientoActualizado.toString().padStart(15, '0');
            for (let mes = 0; mes < 12; mes++) {
                const montoTotalMes = this.documentoDDJJ.tablaMontosMensuales[element.rutTrabajador].find(x => x.mes === mes);
                meseseTrabajadoCadena += this.documentoDDJJ.tablaMesesLiquidado[element.rutTrabajador].some(x => x.mes === mes) ? 'C' : ' ';
                totalMontoMesesCadena +=  montoTotalMes ? montoTotalMes.monto.toString().padStart(12, '0') : String().padStart(12, '0');
            }
            
            const registro = datosInicio+datosTrabajador+meseseTrabajadoCadena+Number(RegistroTipo2.length+1)+totalMontoMesesCadena+String().padStart(59, ' ')+'\n';
            RegistroTipo2.push(registro);
        });
        const totalMontosAnuales = this.documentoDDJJ.tablaMontosTotales;
        const RegistroTipo3:string[] = [
            '311887I'+numeroFolio+this.rutDeclarante,
            totalMontosAnuales.rentaTotal.rentaTotalSinActualizar.toFixed(0).padStart(15, '0'),
            totalMontosAnuales.impuestoUnicoTotalRetenida.retenidoAnio.toFixed(0).padStart(15, '0'),
            totalMontosAnuales.impuestoUnicoTotalRetenida.retenidoAccesoriasComplementaria.toFixed().padStart(15, '0'),
            totalMontosAnuales.rentaTotalNoGravada.rentaTotalNoGravadaSinActualizar.toFixed(0).padStart(15, '0'),
            totalMontosAnuales.rentaTotalExenta.rentaTotalExentaSinActualizar.toFixed(0).padStart(15, '0'),
            totalMontosAnuales.totalRebajasExtremas.rebajaZonasExtremasSinActualizar.toFixed(0).padStart(15, '0'),
            totalMontosAnuales.leyesSociales.toFixed(0).padStart(15, '0'),
            totalMontosAnuales.prestamo3Porciento.prestamo3PorcientoSinActualizar.toFixed(0).padStart(18, '0'),
            totalMontosAnuales.totalRemununeracionImponible.toFixed(0).padStart(15, '0'),
        ];
        for (let mes = 0; mes < 12; mes++) {
            const totalMonto = this.documentoDDJJ.tablaTotalMontosMensuales.find(x => x.mes === mes);
            const registro:string = totalMonto ? totalMonto.monto.toFixed(0).padStart(15, '0') : String().padStart(15, '0');
            RegistroTipo3.push(registro);
        }
        RegistroTipo3.push('\n');

        const length = this.documentoDDJJ.tablaMontosMensuales.reduce((a,e) => {
            return a + 1;
        }, 0)

        const totalMontosAnualesCadena = '32'
            +this.documentoDDJJ.tablaMontosTotales.rentaTotal.rentaTotalActualizado.toFixed(0).padStart(15, '0')
            +this.documentoDDJJ.tablaMontosTotales.impuestoUnicoTotalRetenida.total.toFixed(0).padStart(15, '0')
            +this.documentoDDJJ.tablaMontosTotales.mayorRetencion.toFixed(0).padStart(15, '0')
            +this.documentoDDJJ.tablaMontosTotales.rentaTotalNoGravada.rentaTotalNoGravadaActualizado.toFixed(0).padStart(15, '0')
            +this.documentoDDJJ.tablaMontosTotales.rentaTotalExenta.rentaTotalExentaActualizado.toFixed(0).padStart(15, '0')
            +this.documentoDDJJ.tablaMontosTotales.totalRebajasExtremas.rebajaZonasExtremasActualizado.toFixed(0).padStart(15, '0')
            +this.documentoDDJJ.tablaMontosTotales.prestamo3Porciento.prestamo3PorcientoActualizado.toFixed(0).padStart(18, '0')
            +length.toString().padStart(7, '0')
            +String().padStart(2, '0')+String().padStart(3,'0')+String().padStart(4, '0')
            +this.documentoDDJJ.empresa.cedula.replace(/[.-]/g, '')+String().padStart(206, ' ');

        RegistroTipo3.push(totalMontosAnualesCadena);

        console.log({RegistroTipo0}, {RegistroTipo1}, {RegistroTipo2}, {RegistroTipo3});
        RegistroTipo0.forEach((e:string) => this.textoplano_ddjj1887 += e);
        RegistroTipo1.forEach((e:string) => this.textoplano_ddjj1887 += e);
        RegistroTipo2.forEach((e:string) => this.textoplano_ddjj1887 += e);
        RegistroTipo3.forEach((e:string) => this.textoplano_ddjj1887 += e);
    }
    // CARGA LA LIBRERIA PDFMAKE
    async loadPDFMake(){
        if (!this.pdfMake) {
            const pdfMakeModule = await import('pdfmake/build/pdfmake');
            const pdfFontsModule = await import('pdfmake/build/vfs_fonts');
            this.pdfMake = pdfMakeModule.default;
            this.pdfMake.vfs = pdfFontsModule.default.pdfMake.vfs;
        }
    }
    async convertToPDF(){
        await this.loadPDFMake();
        // EXPORTAR EN PDF
        let contenido = this.pdfContenido();
        const documento = {
            info: {
                title: 'Declaracion-Jurada-1887-'+this.documentoDDJJ.periodoTributario+'.pdf',
            },
            pageSize: {
                width: 1900,
                height: 'auto'
            },
            margin: [20, 20, 20, 20],
            content: [
                ...contenido
            ],
            styles: {
                header: {
                  fontSize: 12,
                  bold: true,
                },
                headerTable: {
                    fontSize: 11,
                    bold: true,
                },
                textTable: {
                    fontSize: 11,
                    bold: false
                }
            }
        }

        this.pdfMake.createPdf(documento).open();        
    }
    // CONTENIDO DEL PDF
    pdfContenido(){
        const pdfMontosAnuales = this.pdfMakeMontosAnuales();
        const pdfMesesLiquidados = this.pdfMakeMesesLiquidados();
        const pdfMontosMensuales = this.pdfMakeMontoMensual();
        const pdfMontosTotalesMensuales = this.pdfTotalMontoMensual();
        const contenido = [
            // HEADER LOGO, TEXT, FOLIO
            {
                columns: [
                    {
                        width: 'auto',
                        stack: [
                            {
                                image: this.LOGO_SII,
                                alignment: 'left',
                                width: 100
                            }
                        ]
                    },
                    {
                        width: 'auto',
                        stack: [
                            {
                                fontSize: 11,
                                text: this.TEXT_HEADER_DOCUMENT,
                                alignment: 'left',
                                margin: [10, 0, 0, 0]
                            },
                            {
                                text: 'AÑO TRIBUTARIO '+this.documentoDDJJ.periodoTributario,
                                margin: [0, 20, 0, 20],
                                alignment: this.DEFAULT_ALIGNMENT,
                                style: 'header'
                            }
                        ]
                    },
                    {
                        width: '*',
                        stack: [
                            {
                                text: 'F1887',
                                alignment: 'left',
                                margin: [200, 0, 0, 0],
                            },
                            {
                                text: 'Folio:', //this.documentoDDJJ.folio
                                style: 'header',
                                alignment: 'left',
                                margin: [200, 0, 0, 0],
                            }
                        ]
                    }
                ]
            },
            // SECCION A: IDENTIFICACION DE LA EMPRESA
            {
                fontSize: 12,
                text: 'Sección A: IDENTIFICACIÓN DEL DECLARANTE (Institución, organismo o persona que efectua retención)'
            },
            {
                margin: [0, 5, 0, 0],
                table: {
                    widths: [85,85,85,85,85,85,85,85,85],
                    body: 
                    [
                        [
                            {text: 'ROL UNICO TRIBUTARIO', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT, colSpan: 2}, 
                            {},
                            {text: 'NOMBRE O RAZON SOCIAL', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT, colSpan: 4}, 
                            {},{},{},
                            {text: 'TIPO DE DECLARACION', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT, colSpan: 3},
                            {},{}
                        ],
                        [
                            {text: this.documentoDDJJ.empresa.run, alignment: this.DEFAULT_ALIGNMENT, colSpan: 2, style: 'textTable'}, 
                            {},
                            {text: this.documentoDDJJ.empresa.nombre, alignment: this.DEFAULT_ALIGNMENT, colSpan: 4, style: 'textTable'}, 
                            {},{},{},
                            {text: 'ORIGINAL', alignment: this.DEFAULT_ALIGNMENT, style: 'headerTable'},
                            {text: 'RECTIFICADA', alignment: this.DEFAULT_ALIGNMENT, style: 'headerTable', colSpan: 2},
                            {}
                        ],
                        [
                            {text: 'DOMICILIO POSTAL', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT, colSpan: 3}, 
                            {},{},
                            {text: 'COMUNA', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT, colSpan: 3}, 
                            {},{},
                            {text: this.documentoDDJJ.estado ? 'X': '', style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                            {text: 'RUT ANTERIOR', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                            {text: this.documentoDDJJ.rutAnterior, style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                        ],
                        [
                            {text: this.documentoDDJJ.empresa.ubicacion, alignment: this.DEFAULT_ALIGNMENT, style: 'textTable', colSpan: 3}, 
                            {},{},
                            {text: this.ciudad.nombre, alignment: this.DEFAULT_ALIGNMENT, style: 'textTable', colSpan: 3}, 
                            {},{},
                            {text: 'MARQUE CON UNA X', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                            {text: 'FOLIO ANTERIOR', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                            {text: this.documentoDDJJ.folioAnterior, style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                        ],
                        [
                            {text: 'CORREO ELECTRONICO', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT, colSpan: 2}, 
                            {},
                            {text: 'FAX', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT, colSpan: 2}, 
                            {},
                            {text: 'TELEFONO', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT, colSpan: 2},
                            {},{},{},{},
                        ],
                        [
                            {text: this.documentoDDJJ.empresa.correo, alignment: this.DEFAULT_ALIGNMENT, style: 'textTable', colSpan: 2}, 
                            {},
                            {text: '', alignment: this.DEFAULT_ALIGNMENT, style: 'textTable', colSpan: 2}, 
                            {},
                            {text: this.documentoDDJJ.empresa.num_telefono ? this.documentoDDJJ.empresa.num_telefono : '', alignment: this.DEFAULT_ALIGNMENT, style: 'textTable', colSpan: 2},
                            {},{},{},{},
                        ],
                    ]
                }
            },
            // SECCION B: DATOS DE LOS INFORMADOS
            {
                margin: [0, 20, 0, 0],
                fontSize: 12,
                text: 'Sección B: DATOS DE LOS INFORMADOS (Receptor de la Renta: Sueldos, Sobresueldos, Salarios y Rentas similares)',
            },
            {
                columns: [
                    {
                        width: 'auto',
                        margin: [0, 5, 0, 0],
                        alignment: 'left',
                        table: {
                            headerRows: 2,
                            widths: 
                            [
                                'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 
                            ],
                            body: 
                            [
                                [
                                    {rowSpan: 2, text: 'N°', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT}, //Numero registro
                                    {rowSpan: 2, 
                                        text: 'RUT DE LA PERSONA\nA QUIEN SE LE PAGO\nLA RENTA (Trabajador)', 
                                        style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT, verticalAlignment: 'middle'},
                                    {text: 'MONTOS ANUALES ACTUALIZADOS', colSpan: 7, style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {},{},{},{},{},{}
                                ],
                                [
                                    {},{},
                                    {text: 'RENTA TOTAL NETA\nPAGADA\n(Art. 42 N° 1 LIR)', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'IMPUESTO UNICO\nRETENIDO', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'MAYOR RETENCION\nSOLICITADA\n(Art. 88 LIR)', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'RENTA TOTAL\nNO GRAVADA', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'RENTA TOTAL\nEXENTA', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'REBAJA POR ZONAS\nEXTREMAS\n(Franquicia DL 889)', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '3% PRÉSTAMO\nTASA 0%\nAÑO 2020-2021', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                ], ...pdfMontosAnuales
                            ],
                        }
                    },
                    {
                        width: 'auto',
                        margin: [-1, 5, -1, 0],
                        alignment: 'left',
                        table: {
                            headerRows: 2,
                            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                            body: [
                                [
                                    {text: 'PERIODO AL CUAL CORRESPONDE LAS RENTAS', colSpan: 12, style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {},{},{},{},{},{},{},{},{},{},{}
                                ],
                                [
                                    {text: '\n\n\nENE\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nFEB\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nMAR\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nMAY\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nABR\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nJUN\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nJUL\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nAGO\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nSEP\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nOCT\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nNOV\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nDIC\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                ], ...pdfMesesLiquidados
                            ]
                        }
                    },
                    {
                        width: 'auto',
                        margin: [0, 5, 0, 0],
                        alignment: 'left',
                        table: {
                            headerRows: 2,
                            widths: [70, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60],
                            body: [
                                [
                                    {rowSpan: 2, text: 'N°\nCERTIFICADO', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'MONTO INGRESO MENSUAL (Sin Actualizar)', colSpan: 12, style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {},{},{},{},{},{},{},{},{},{}, {}
                                ],
                                [
                                    {},
                                    {text: '\n\n\nENE\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nFEB\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nMAR\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nMAY\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nABR\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nJUN\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nJUL\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nAGO\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nSEP\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nOCT\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nNOV\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nDIC\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                ], ...pdfMontosMensuales
                            ]
                        }
                    }
                ],
            },
            // SECCION B: TOTALES Y TOTALES MENSUALES SIN ACTUALIZAR
            {
                margin: [0, 20, 0, 0],
                columns: [
                    {
                        width: 'auto',
                        alignment: 'left',
                        table: {
                            widths: 
                            [
                                'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 150, 
                            ],
                            body: 
                            [
                                [
                                    {text: 'TOTAL MONTOS ANUALES SIN ACTUALIZAR', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT, colSpan: 8},
                                    {},{},{},{},{},{},{},
                                    {rowSpan: 2, text: 'TOTAL REMUNERACIÓN IMPONIBLE PARA EFECTOS PREVISIONALES ACTUALIZADA A TODOS LOS TRABAJADORES', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT}
                                ],
                                [
                                    {text: 'RENTA TOTAL NETA\nPAGADA\n(Art. 42 N° 1 LIR)', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'IMPUESTO UNICO\nRETENIDO\nPOR RENTA TOTAL\nNETA PAGADA\nDURANTE EL AÑO', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'IMPUESTO UNICO RETENIDO\nPOR RENTAS ACCESORIAS\nY/O COMPLEMENTARIA PAGADA\nENTRE ENE-ABR AÑO SGTE.', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'RENTA TOTAL\nNO GRAVADA', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'RENTA TOTAL\nEXENTA', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'REBAJA POR ZONAS\nEXTREMAS\n(Franquicia DL 889)', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'LEYES SOCIALES', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '3% PRÉSTAMO\nTASA 0%\nAÑO 2020-2021', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {},
                                ],
                                [
                                    {text: this.formatearNumeros(this.documentoDDJJ.tablaMontosTotales.rentaTotal.rentaTotalSinActualizar), style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: this.formatearNumeros(this.documentoDDJJ.tablaMontosTotales.impuestoUnicoTotalRetenida.retenidoAnio),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: this.formatearNumeros(this.documentoDDJJ.tablaMontosTotales.impuestoUnicoTotalRetenida.retenidoAccesoriasComplementaria),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: this.formatearNumeros(this.documentoDDJJ.tablaMontosTotales.rentaTotalNoGravada.rentaTotalNoGravadaSinActualizar),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: this.formatearNumeros(this.documentoDDJJ.tablaMontosTotales.rentaTotalExenta.rentaTotalExentaSinActualizar),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: this.formatearNumeros(this.documentoDDJJ.tablaMontosTotales.totalRebajasExtremas.rebajaZonasExtremasSinActualizar),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: this.formatearNumeros(this.documentoDDJJ.tablaMontosTotales.leyesSociales),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: this.formatearNumeros(this.documentoDDJJ.tablaMontosTotales.prestamo3Porciento.prestamo3PorcientoSinActualizar),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: this.formatearNumeros(this.documentoDDJJ.tablaMontosTotales.totalRemununeracionImponible),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                ]
                            ],
                        }
                    },
                    {
                        width: 'auto',
                        alignment: 'left',
                        margin: [-1, 0, 0, 0],
                        table: {
                            widths: 
                            [
                                60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60 
                            ],
                            body: 
                            [
                                [
                                    {text: 'TOTAL MONTOS ANUALES SIN ACTUALIZAR', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT, colSpan: 12},
                                    {},{},{},{},{},{},{},{},{},{},{}
                                ],
                                [
                                    {text: '\n\n\nENE\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nFEB\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nMAR\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nABR\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nMAY\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nJUN\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nJUL\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nAGO\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nSEP\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nOCT\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nNOV\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '\n\n\nDIC\n\n\n', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                ],[
                                    ...pdfMontosTotalesMensuales
                                ] 
                            ],
                        }
                    },
                ]
            },
            // SECCION B: TOTALES ACTUALIZADOS
            {
                margin: [0, 20, 0, 0],
                columns: [
                    {
                        width: 'auto',
                        alignment: 'left',
                        table: {
                            widths: 
                            [
                                'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto',
                            ],
                            body: 
                            [
                                [
                                    {text: 'CUADRO DE RESUMEN DE LA DECLARACIÓN', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT, colSpan: 8},
                                    {},{},{},{},{},{},{}
                                ],
                                [
                                    {text: 'TOTAL MONTOS ANUALES ACTUALIZADOS', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT, colSpan: 7},
                                    {},{},{},{},{},{},
                                    {rowSpan: 2, text: 'TOTAL DE CASOS INFORMADOS', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT}
                                ],
                                [
                                    {text: 'RENTA TOTAL NETA\nPAGADA\n(Art. 42 N° 1 LIR)', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'IMPUESTO UNICO\nRETENIDO', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'MAYOR RETENCION\nSOLICITADA\n(Art. 88 LIR)', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'RENTA TOTAL\nNO GRAVADA', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'RENTA TOTAL\nEXENTA', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: 'REBAJA POR ZONAS\nEXTREMAS\n(Franquicia DL 889)', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: '3% PRÉSTAMO\nTASA 0%\nAÑO 2020-2021', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {},
                                ],
                                [
                                    {text: this.formatearNumeros(this.documentoDDJJ.tablaMontosTotales.rentaTotal.rentaTotalActualizado), style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: this.formatearNumeros(this.documentoDDJJ.tablaMontosTotales.impuestoUnicoTotalRetenida.total),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: this.formatearNumeros(this.documentoDDJJ.tablaMontosTotales.mayorRetencion),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: this.formatearNumeros(this.documentoDDJJ.tablaMontosTotales.rentaTotalNoGravada.rentaTotalNoGravadaActualizado),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: this.formatearNumeros(this.documentoDDJJ.tablaMontosTotales.rentaTotalExenta.rentaTotalExentaActualizado),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: this.formatearNumeros(this.documentoDDJJ.tablaMontosTotales.totalRebajasExtremas.rebajaZonasExtremasActualizado),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: this.formatearNumeros(this.documentoDDJJ.tablaMontosTotales.prestamo3Porciento.prestamo3PorcientoSinActualizar),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                    {text: this.documentoDDJJ.tablaMontosAnuales.length,  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                                ]
                            ],
                        }
                    },
                ]
            },
            {
                margin: [0, 20, 0, 0],
                text: 'DECLARO BAJO JURAMENTO QUE LOS DATOS CONTENIDOS EN EL PRESENTE DOCUMENTO SON LA EXPRESIÓN FIEL DE LA VERDAD, POR LO QUE ASUMO LA RESPONSABILIDAD CORRESPONDIENTE',
                fontSize: 12
            },
            {
                margin: [0, 5, 0, 0],
                table: {
                    widths: ['auto'],
                    body: [
                        [
                            {text: 'RUT REPRESENTANTE LEGAL', style: 'headerTable', alignment: this.DEFAULT_ALIGNMENT}
                        ],
                        [
                            {text: this.documentoDDJJ.empresa.cedula, style: 'textTable', alignment: this.DEFAULT_ALIGNMENT}
                        ],
                    ]
                }
            }
        ]
        return contenido;
    }
    // GENERA EL CUERPO DE LA TABLA MONTOS TOTALES MENSUALES DEL DOCUMENTO DDJJ
    pdfTotalMontoMensual(){
        let mesesTotales = new Array(12).fill(0);
        Object.keys(this.documentoDDJJ.tablaMontosMensuales).forEach((rut) => {
            this.documentoDDJJ.tablaMontosMensuales[rut].forEach(({mes, monto}) => {
                mesesTotales[mes] += monto;
            });
        });
        const filas = mesesTotales.map(total => ({
            text: this.formatearNumeros(total),
            style: 'textTable',
            alignment: this.DEFAULT_ALIGNMENT,
        }));
        // console.log('Filas total monto mensual: ', filas);
        return filas;
    }
    // GENERA EL CUERPO DE LA TABLA MONTOS ANUALES DEL DOCUMENTO DDJJ
    pdfMakeMontosAnuales(){
        let filas = [];
        for (let index = 0; index < this.documentoDDJJ.tablaMontosAnuales.length; index++) {
            const registro = this.documentoDDJJ.tablaMontosAnuales[index];
            let fila = [
                {text: index+1, style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                {text: formatRut(registro.rutTrabajador),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                {text: this.formatearNumeros(registro.rentaTotalTrabajador.rentaActualizada),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                {text: this.formatearNumeros(registro.impuestoUnicoTrabajador.impuestoActualizado),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                {text: this.formatearNumeros(registro.mayorRetenecionTrabajador.mayorRetencionActualizado),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                {text: this.formatearNumeros(registro.rentaTotalNoGravadaTrabajador.rentaTotalNoGravadaActualizado),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                {text: this.formatearNumeros(registro.rentaTotalExentaTrabajador.rentaTotalExentaActualizado),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                {text: this.formatearNumeros(registro.rebajaZonasExtremasTrabajador.rebajaZonasExtremasActualizado),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
                {text: this.formatearNumeros(registro.prestamo3PorcientoTrabajador.prestamo3PorcientoActualizado),  style: 'textTable', alignment: this.DEFAULT_ALIGNMENT},
            ];

            filas.push(fila);
        }
        // console.log('Filas monto anual: ', filas);
        return filas;
    }
    // GENERA EL CUERPO DE LA TABLA MESES LIQUIDADOS DEL DOCUMENTO DDJJ
    pdfMakeMesesLiquidados(){
        let filas = [];
        Object.keys(this.documentoDDJJ.tablaMesesLiquidado).forEach(rut => {
            const mesesLiquidado:TablaMesesLiquidados[] = this.documentoDDJJ.tablaMesesLiquidado[rut];
            const fila = [];            
            for (let mes = 0; mes < 12; mes++) {
                // SI NO EXISTE EL MES, ASIGNAR -1 PARA VERIFICAR NULO
                const liquidado = mesesLiquidado.find(x => x.mes === mes)?.mes || -1;
                fila.push({text:  liquidado > -1 ? 'C' : '', style: 'textTable', alignment: this.DEFAULT_ALIGNMENT});
            }

            filas.push(fila);
        });
        // console.log('Filas meses liquidados: ', filas);
        // console.log(filas);
        return filas;
    }
    // GENERA EL CUERPO DE LA TABLA MONTOS MENSUALES DEL DOCUMENTO DDJJ
    pdfMakeMontoMensual(){
        let filas = [];
        Object.keys(this.documentoDDJJ.tablaMontosMensuales).forEach((rut, index) => {
            const mesesMontos:TablaMontosMensuales[] = this.documentoDDJJ.tablaMontosMensuales[rut];
            
            const fila = [{text: (index + 1).toString(), style: 'textTable', alignment: this.DEFAULT_ALIGNMENT}];
            for (let mes = 0; mes < 12; mes++) {
                const monto = mesesMontos.find(x => x.mes === mes)?.monto || 0;
                fila.push({text: this.formatearNumeros(monto), style: 'textTable', alignment: this.DEFAULT_ALIGNMENT});
            }

            filas.push(fila);
        });
        // console.log('Filas monto mensual: ', filas);
        return filas;
    }
    // CARGA LOS TRABAJADORES Y SUS DATOS EN UNA LISTA
    cargarDatosTrabajadores(anio:number, idEmpresa:number){
        try {
            return new Promise(async(resolve) => {
                this.anio = anio;
                const { data } = await this.trabajadorservice.TraerTrabajadores().toPromise();
                this.trabajadores = data.filter
                (
                    ({ Empresa_contratante }) => Empresa_contratante.id === idEmpresa
                );
                const promesas = this.trabajadores.map(async (trabajador) => {
                    const {data: libroContable} = await this.ventaService.traerTodoLibroRemu().toPromise() as { data:any[] };
                    // console.log(libroContable);
                    if (libroContable.find(lc => lc.rut === trabajador.rut)) {
                        this.libroRemuneraciones[trabajador.rut] = libroContable.filter(({rut}) => trabajador.rut === rut);
                        return Promise.resolve();            
                    }
                });
                await Promise.all(promesas);
                resolve(1);
            });    
        } catch (error) { throw Error("Error: "+error) }
        
    }

    // FILTRA LAS LIQUIDACIONES DEL LIBRO DE CONTABILIDAD DE ACUERDO AL PERIODO SELECCIONADO
    filtarLiquidaciones() : boolean{
        const periodoInicial = new Date(this.anio, 0, 1);
        const periodoFinal = new Date(this.anio, 11, 31);

        return this.libroRemuneraciones.some((libro: any[]) => {
            // console.log({libro});
            return libro.some((l: any) => {
                const fecha = new Date(l.f_liquidacion+'T00:00:00');
                return fecha >= periodoInicial && fecha <= periodoFinal;
            });
        });
    }
    // FORMATEA LOS NUMEROS CON SEPARADORES DE MILES
    formatearNumeros(numero:number):string{
        const opciones = {
            useGrouping: true,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            minimumIntegerDigits: 1,
        };
        return numero.toLocaleString('es', opciones);
    }
}